import React from 'react'
import Introduction from '../Components/Introduction'
import nexxfixx from '../Assets/logo-nexxfixx2.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import ResultsDifferences from '../Components/ResultsDifferences'
import GeographicPresence from '../Components/GeographicPresence'
import MarketAnalysis from '../Components/MarketAnalysis'
import SystemNexx from '../Assets/nexxfixx-sistema.webp'

function Nexxfixx({ id }) {
  return (
    <section id={id} className="background-light">
      <Introduction
        srcLogo={nexxfixx}
        altLogo="Nexx Fixx"
        description={
          <>
            A Nexx Fixx consolida-se como um pilar fundamental de inovação
            tecnológica, atuando como a principal{' '}
            <span>
              provedora de soluções tecnológicas para o Grupo Fixx e para
              terceiros
            </span>
            . Com sede em Paranavaí-PR e colaboradores distribuídos por todo o
            Brasil, a empresa é especializada no desenvolvimento de algoritmos
            de ocupação, aplicativos, softwares, e na monitorização do mercado,
            incluindo commodities e operações no mercado de ativos. A Nexx Fixx
            é reconhecida por sua capacidade de criar soluções tecnológicas
            avançadas, posicionando o Grupo Fixx como líder em inovação e
            tecnologia.
          </>
        }
        backgroundColor="linear-gradient(#8A288F, #6A2C91)"
        color="white"
        img={true}
        srcProduct={SystemNexx}
        altProduct="Sistema da Nexx Fixx"
      />

      <Services backgroundColor="#6A2B90" colorTitle="white">
        <CardServices
          title="Desenvolvimento Tech Advanced"
          description="A Nexx Fixx é responsável pelo desenvolvimento e manutenção de uma ampla gama de tecnologias de ponta, incluindo aplicativos e softwares que são cruciais para a operação do Grupo Fixx e de terceiros."
          backgroundColor="white"
          colorTitle="#6A2C91"
          colorContent="#706d7e"
          height="240px"
        />
        <CardServices
          title="Algoritmos"
          description="Criação de algoritmos de automação para mercados específicos, oferecendo soluções personalizadas."
          backgroundColor="white"
          colorTitle="#6A2C91"
          colorContent="#706d7e"
          height="240px"
        />
        <CardServices
          title="Propriedade e Inovação"
          description="Todas as ferramentas, aplicativos e tecnologias desenvolvidas pela Nexx Fixx são de sua propriedade exclusiva, garantindo a originalidade e a competitividade de suas soluções no mercado."
          backgroundColor="white"
          colorTitle="#6A2C91"
          colorContent="#706d7e"
          height="240px"
        />
      </Services>

      <ResultsDifferences
        id="nexxfixx-background"
        description="A expertise da Nexx Fixx em antecipar tendências tecnológicas e desenvolver soluções sob medida coloca tanto a empresa quanto seus clientes em uma posição vantajosa no mercado. Sua habilidade em adaptar-se rapidamente às mudanças tecnológicas é fundamental para a sustentabilidade e o crescimento no ambiente de negócios em constante evolução."
        backgroundColor="linear-gradient(#8A288F, #6A2C91)"
        colorTitle="white"
        colorContent="white"
      />

      <MarketAnalysis
        description={
          <>
            <br />
            <br />
            O setor de tecnologia vive uma era de transformações rápidas, com
            demanda crescente por otimização de processos, aumento da eficiência
            e melhoria da experiência do usuário. A Nexx Fixx se posiciona como
            uma líder em inovação tecnológica, capaz de desenvolver soluções
            avançadas e seguras que atendem às necessidades emergentes dos
            negócios.
            <br />
            <br /> A digitalização acelerada dos mercados amplia as
            oportunidades para empresas como a Nexx Fixx, destacando a
            importância da tecnologia de alta performance.
          </>
        }
        backgroundColor="white"
        colorTitle="#6A2C91"
        colorContent="#706d7e"
        colorSvg="#6A2C91"
        news={
          <>
            O total de investimentos globais em tecnologia da informação
            (software, hardware e serviços) durante o ano de 2021 foi de{' '}
            <span>US$ 2,79 trilhões</span>, sendo que o Brasil figura na{' '}
            <span>décima posição neste ranking mundial de investimentos</span>,
            com <span>US$ 45,7 bilhões</span> aplicados, e lidera na América
            Latina.
          </>
        }
        backgroundNews="#88288F"
        colorNews="white"
      />

      <GeographicPresence description="Com sua sede em Paranavaí-PR e uma equipe de colaboradores em todo o Brasil, a Nexx Fixx possui uma presença geográfica abrangente que lhe permite atender clientes em todo o território nacional, potencializando seu alcance e influência no mercado de tecnologia." />
    </section>
  )
}

export default Nexxfixx
